import type { FormKitNode } from '@formkit/core'

export default (node: FormKitNode) => {
  const value = node.value as string

  const urlPattern = new RegExp(
    '^(https?:\\/\\/)?' +
      '((?:[a-zA-Z0-9-]+\\.){1,}[a-zA-Z]{2,})' +
      '\\/' +
      '[^\\s?#]*' +
      '(\\?[^\\s]*)?' +
      '(#[^\\s]*)?' +
      '$',
    'i'
  )

  return !!urlPattern.test(value)
}
